import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { useLocation } from 'react-router-dom';
import { Parallax } from "react-parallax";
import image1 from "./images/keyboard.jpg";
import ProjectsData from '../Projects/ProjectsData';
import TestimonialSlider from './TestimonialSlider';
import Clients from "./Clients";
import { Link } from 'react-router-dom';

const techStackTerms = [
    "JavaScript",
    "React",
    "Node.js",
    "Python",
    "Angular",
    "Vue.js",
    "HTML5",
    "CSS3",
    "Sass",
    "MongoDB",
    "SQL",
    "Express.js",
    "Django",
    "Ruby",
    "C#",
];

const techStackTerms2 = [
    "REST API",
    "GraphQL",
    "Webpack",
    "Redux",
    "Vue.js",
    "TypeScript",
    "SASS/SCSS",
    "Firebase",
    "TensorFlow",
    "PyTorch",
    "D3.js",
    "Bootstrap",
    "Material-UI",
    "Webpack",
    "Elasticsearch",
];

const techStackTerms3 = [
    "ASP.NET",
    "Spring Boot",
    "PHP",
    "Laravel",
    "AWS",
    "Docker",
    "Kubernetes",
    "Git",
    "Jenkins",
    "CI/CD",
    "Kibana",
    "Redis",
    "PostgreSQL",
    "MySQL",
];

const Home = () => {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            }, 100);
        }
        
    }, [hash]);

    
    return (
        <>
           
            <div className="hero-home-page" >
                <div className="container-full-width">
                    <div className="left-right-wrapper animate__animated animate__fadeIn">
                        <div className="left-col">
                            <h1 className="animate__animated animate__fadeInUp">FULL-STACK WEB & DIGITAL SOLUTIONS.</h1>
                            <h2 className="title animate__animated animate__fadeInUp">WE DON'T JUST CODE, BUT LIVE FOR IT.</h2>
                            <Link to={'/services/'} className="me-3">OUR SERVICES</Link>
                            <Link to={'/projects/'} className="">OUR WORK</Link>
                        </div>
                    </div>
                </div>
                
                <div className="video-wrapper">
                    {/* <iframe
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                        frameborder="0"
                        // src="https://player.vimeo.com/video/1091533791?autoplay=1&loop=1&muted=1&autopause=0&background=1&badge=0"
                        loop="" autoPlay="" muted="" playsInline="" 
                        title="Vimeo Video"
                        loading="eager"
                        // onLoad={handleVideoLoad}
                    /> */}

                    <video
                        src="https://cdn.jsdelivr.net/gh/devsdg7/Videos/video11.mp4"
                        // src="https://video-previews.elements.envatousercontent.com/dad08779-a0f0-4906-81c6-dd2580e0666d/watermarked_preview/watermarked_preview.mp4"
                        // src="https://video-previews.elements.envatousercontent.com/ff054151-2cec-44f9-aa6f-8b9d864fa723/watermarked_preview/watermarked_preview.mp4"
                        loop
                        autoPlay
                        muted
                        playsInline
                        onCanPlay={() => console.log('Video ready to play')}
                    />


                </div>
            </div>

                <>
                    <section id="intro-wrapper" className=""></section>
                    
                    <div className="section section-recent-projects">
                        <div className="container-full-width">
                            <div className="small-title">OUR WORK.</div>
                            <h2 className="section-title">RECENT PROJECTS.</h2>
                            <div className="projects-items-wrapper">
                                <ProjectsData max_items="6"/>
                            </div>
                        </div>
                    </div>
                    
                    <div className="section section-marquee-text border-top-bottom container-full-width">
                        <div className="container-full-width">
                            <div className="small-title">SPECIALITIES.</div>
                            <h2 className="section-title">TECH STACKS.</h2>
                        </div>
                        <div className="border-top-bottom py-5 mx-5 wrapper-marquee-tech-stacks">
                            <Marquee direction="right" speed="100">
                                {techStackTerms.map((term, index) => (
                                    <h2 key={index} className="text-item">{techStackTerms.join(" / ")}</h2>
                                ))}
                            </Marquee>
                            <Marquee direction="left" speed="100">
                                {techStackTerms.map((term, index) => (
                                    <h2 key={index} className="text-item">{techStackTerms2.join(" / ")}</h2>
                                ))}
                            </Marquee>
                            <Marquee direction="right" speed="100">
                                {techStackTerms.map((term, index) => (
                                    <h2 key={index} className="text-item">{techStackTerms3.join(" / ")}</h2>
                                ))}
                            </Marquee>
                        </div>
                    </div>
                    
                    <Parallax bgImage={image1} strength={500}>
                        <div className="parallax-home" style={{ height: 500 }}>
                            <div className="inner-text">
                                <div className="container-full-width">
                                    <div className="small-title text-white">GET IN TOUCH.</div>
                                </div>
                                <h2 className="container-full-width display-4 main-text">
                                    IF YOU CAN IMAGINE IT,
                                    <br />WE CAN BUILD IT.
                                </h2>
                            </div>
                        </div>
                    </Parallax>
                    
                    <div id="section-clients" className="section section-clients border-bottom border-top container-full-width">
                        <div className="container-full-width">
                            <div className="small-title">CLIENTS.</div>
                            <h2 className="section-title">our evolutionary client network.</h2>
                            <div className="border-top pt-5 wrapper-marquee-clients">
                                <Clients />
                            </div>
                        </div>
                    </div>
                    
                    <div id="client-testimonials" className="section section-testimonials container-full-width">
                        <div className="container-full-width">
                            <div className="small-title">TESTIMONIALS.</div>
                            <h2 className="section-title">WHAT OUR CLIENTS SAY.</h2>
                            <TestimonialSlider />
                        </div>
                    </div>
                </>
        </>
    );
}

export default Home;
